// export const filteredNavConfig = (navItems, navConfig) =>
//   navConfig.map((config) => {
//     const filteredItems = config.items.filter((item) =>
//       navItems.includes(item.path)
//     );
//     const filteredChildrens = config.items
//       .map((item1) => {
//         const data = item1.children?.filter((item2) =>
//           navItems.includes(item2.path)
//         );
//         if (data?.length > 0) {
//           item1.children = item1.children.filter((item3) =>
//             data.find((item4) => item4.path === item3.path)
//           );
//           return {
//             ...item1,
//           };
//         }
//       })
//       .filter(Boolean);
//     console.log(navItems);
//     console.log(filteredItems);
//     console.log(filteredChildrens);
//     return { ...config, items: [...filteredItems, ...filteredChildrens] };
//   });
export const filteredNavConfig = (navItems, navConfig) =>
  navConfig.map((config) => {
    const filteredMenu = config.items.map((item) => {
      if (item.children === undefined) {
        if (navItems.includes(item.path)) return item;
      } else {
        const data = item.children?.filter((item2) =>
          navItems.includes(item2.path)
        );
        if (data?.length > 0) {
          item.children = item.children.filter((item3) =>
            data.find((item4) => item4.path === item3.path)
          );
          return {
            ...item,
          };
        }
      }
    });
    const menuItems = filteredMenu.filter((item) => item !== undefined);
    return { ...config, items: [...menuItems] };
  });
